<template>
    <div>
        <div class="pb-4 mt-4 mx-4">
            <b-overlay :show="show" rounded="sm">
                <b-card class="py-0">
                    <b-row>
                        <b-col md="4" class="pl-4 mb-5 mb-md-0">
                            <h6 class="titleUnderline">Detalles del documento</h6>
                            <div class="mt-3 mb-2 ml-2">
                                <b-icon-file-earmark-text font-scale="1.6"
                                    class="bg-custom p-1 rounded"></b-icon-file-earmark-text>
                                <span class="ml-2 details-subtitle cs-pointer" v-if="pdf_name" v-b-tooltip.hover
                                    title="Vista previa" @click="showPreview()">{{ pdf_name }}.pdf</span>
                            </div>
                            <b-modal id="preview" centered no-close-on-backdrop hide-footer>
                                <template #modal-title>
                                    <h4>Vista previa del documento</h4>
                                </template>
                                <b-row>
                                    <b-col>
                                        <embed :src="src" height="600" type='application/pdf'
                                            style="width:inherit!important">
                                    </b-col>
                                </b-row>
                            </b-modal>
                            <div class="mt-3 mb-1">
                                <span class="details-subtitle ml-2">Creado el:</span>
                                <div class="summary-title ml-2" v-if="pdf_created"> {{ new Date(pdf_created) |
                                    date('dd/MM/yyyy') }}</div>
                            </div>
                            <div class="mt-2 mb-1">
                                <span class="details-subtitle ml-2">Estado:</span>
                                <div class="summary-title ml-2"> {{ state }}</div>
                            </div>
                            <template v-if="isBlockchainActive == true">
                                <h6 class="titleUnderline mt-4">Informaci&oacute;n blockchain</h6>
                                <div class="mt-3 mb-1">
                                    <span class="details-subtitle ml-2">Transacci&oacute;n:</span>
                                    <div class="summary-title ml-2"><a class="text-danger" :href="urltx"
                                            target="_blank">
                                            {{ tx }} </a></div>
                                </div>
                                <div class="mt-2 mb-1">
                                    <span class="details-subtitle ml-2">Red:</span>
                                    <div class="summary-title ml-2"> {{ network }}</div>
                                </div>
                                <div class="mt-2 mb-1">
                                    <span class="details-subtitle ml-2">Hash:</span>
                                    <div class="summary-title ml-2"> {{ hash }}</div>
                                </div>
                            </template>

                        </b-col>
                        <b-col md="8" class="pl-4 mb-5 mb-md-0">
                            <h6 class="titleUnderline mb-0">Destinatario</h6>
                            <b-overlay :show="imagesLoading" rounded="sm" >
                                <b-row>
                                    <b-col md="5">
                                        <div class="mt-3 mb-1">
                                            <span class="details-subtitle ml-2">Usuario:</span>
                                            <select class="mt-1 ml-1 custom-select custom-select-sm sender-select"
                                                v-model="selected_signed_user"
                                                @change="getSenderInfo($event.target.value)">
                                                <option :value="null">Seleccione un usuario</option>
                                                <option v-for="(item, index) in senders" :key="index"
                                                    :value="item.SendTo">
                                                    {{ item.Name }}</option>
                                            </select>
                                        </div>
                                        <template v-if="selected_signed_user">
                                            <div class="mt-2 mb-1">
                                                <span class="details-subtitle ml-2">Email:</span>
                                                <div class="summary-title ml-2"> {{ senderEmail }}</div>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <span class="details-subtitle ml-2">Fecha de firma:</span>
                                                <div class="summary-title ml-2" v-if="signDate"> {{ new Date(signDate) |
                                                    date('dd/MM/yyyy') }}</div>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <span class="details-subtitle ml-2">Tipo de firma:</span>
                                                <div class="summary-title ml-2">{{ getNameById(pdf_signature_type) }}
                                                </div>
                                            </div>
                                        </template>
                                    </b-col>
                                    <b-col md="7" class="text-md-center">
                                        <div class="mt-3 mb-1">
                                            <span class="details-subtitle ml-2">Capturas del usuario durante la
                                                firma:</span>
                                            <carousel :per-page="1" :mouse-drag="false" :adjustableHeight="true"
                                                v-if="selected_signed_user" class="mt-3">
                                                <slide v-for="(user_image, index) in user_captured.ClientImage"
                                                    :key="index" :index="index">
                                                    <img :src="user_image" @click="zoomImage(user_image)" />
                                                </slide>
                                            </carousel>
                                            <b-modal id="zoomImage" size="lg" centered no-close-on-backdrop hide-footer
                                                v-model="imageModal">
                                                <div class="row text-center my-4">
                                                    <div class="col">
                                                        <img :src="selectedImage" @click.stop="imageModal = false" />
                                                    </div>
                                                </div>
                                            </b-modal>
                                        </div>
                                    </b-col>
                                </b-row>
                                <template v-slot:overlay>
                                    <div class="text-center">
                                        <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary" animation="spin"
                                            font-scale="3"></b-icon>
                                    </div>
                                </template>
                            </b-overlay>
                        </b-col>
                    </b-row>
                    <div class="titleUnderline mt-4"></div>
                    <b-row>
                        <b-col class="text-right mt-2">
                            <div style="font-size: 2rem;">
                                <b-icon-arrow-left id="back" aria-hidden="true" @click="backToList"
                                    class="action-details-btn mr-3" scale="0.6"></b-icon-arrow-left>
                                <b-icon-printer id="print" aria-hidden="true" @click="printPdf"
                                    class="action-details-btn mr-3" scale="0.6"></b-icon-printer>
                                <b-icon-file-earmark-arrow-down id="download" aria-hidden="true" @click="downloadPdf"
                                    class="action-details-btn mr-3" scale="0.6"></b-icon-file-earmark-arrow-down>

                                <b-icon-file-earmark-lock id="download" aria-hidden="true" @click="generateReport"
                                    class="action-details-btn" scale="0.6"></b-icon-file-earmark-lock>

                            </div>
                        </b-col>
                    </b-row>
                </b-card>
                <template v-slot:overlay>
                    <div class="text-center">
                        <b-icon icon="arrow-clockwise" class="mt-4 text-cid-primary" animation="spin"
                            font-scale="3"></b-icon>
                    </div>
                </template>
            </b-overlay>
            <b-modal id="preview-report" ref="preview-report" size="xl" centered no-close-on-backdrop hide-footer>
                <div class="container_mouse">
                    <span class="mouse-btn">
                        <span class="mouse-scroll"></span>
                    </span>
                </div>
                <!-- Renderizar PdfContent fuera del Shadow DOM -->
                <div id="container-elementoPDF" class="p-3"
                    style=" overflow-x: scroll; white-space: nowrap;-webkit-scrollbar {display: none;}">
                    <ReportViewSigned id="elementoPDF" ref="elementoPDF" :data="reportData"
                        @pdf-generado="hideGeneratePDF" />
                </div>

                <!-- Botón para generar el PDF -->
                <cid-button ref="btnGenerarPdf" pill size="lg" block class="px-4 floating-button" @click="setPDF">
                    Generar PDF
                </cid-button>
            </b-modal>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { Carousel, Slide } from 'vue-carousel';
import ReportViewSigned from './generate-report/ReportViewSigned.vue';
import { generarPDF } from './PDF.js/PDF';

export default {
    name: 'view-signed-doc',
    components: {
        Carousel,
        Slide,
        ReportViewSigned
    },
    data() {
        return {
            show: true,
            pdf_id: this.$route.params.id,
            pdf_name: null,
            pdf_created: null,
            state: null,
            senders: [],
            selected_signed_user: null,
            senderEmail: null,
            signDate: null,
            user_captured: [],
            hash: null,
            imagesLoading: false,
            print: false,
            current_email: this.$store.state.userEmail,
            name: null,
            email: null,
            security_id: null,
            token: localStorage.getItem('access_token'),
            src: null,
            tx: null,
            network: null,
            urltx: null,
            imageModal: false,
            selectedImage: null,
            isBlockchainActive: false,
            reportData: null,
            userPositionSignatures: null,
            pdf_folder: null,
            pdf_creator_name: null,
            pdf_creator_email: null,
            pdf_signature_type: null,
            sign_options: [
                { id: 1, name: "Dispositivo Móvil", },
                { id: 2, name: "Otp", },
                //{ id: 3, name: "Certificado Digital"},
                { id: 4, name: "A Elección del Usuario", }
            ],
        };
    },
    async mounted() {
        this.isBlockchainActive = this.$store.state.userBlockchain == 'true';
        await this.initialValidation();
        this.getFileDetail();
        this.getBlockchainDetail();
        await this.$store.dispatch("load");
    },
    methods: {
        getFileDetail() {
            if (this.$route.params.user && this.$route.params.user != "Multifirma") {
                this.name = this.$route.params.user;
            }
            if (this.$route.params.email) {
                this.email = this.$route.params.email;
            }
            if (this.$route.params.security) {
                this.security_id = this.$route.params.security;
                this.$store.dispatch("destroyToken").then(() => { });
            }
            if (this.$store.getters.loggedIn) {
                this.email = this.current_email;
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;
            axios.get('/api/File/GetFileById/' + this.pdf_id + '/' + this.name + '/' + this.email + '/' + this.security_id).then(response => {
                if (response.data.IsSuccessFul) {
                    this.show = false;
                    this.pdf_name = response.data.Result.DocumentName;
                    this.pdf_created = response.data.Result.Created;
                    this.state = response.data.Result.State;
                    this.senders = response.data.Result.EmailList;
                    this.hash = response.data.Result.HashSignature;
                    this.userPositionSignatures = response.data.Result.UserFileSignaturePositions.length;
                    this.pdf_folder = response.data.Result.FolderName;
                    this.pdf_creator_email = response.data.Result.Email;
                    this.pdf_creator_name = response.data.Result.UserName;
                    this.pdf_signature_type = response.data.Result.SignatureOption;
                }
            });
        },
        getBlockchainDetail() {

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;
            axios.get('/api/File/getBlockchainInfo/' + this.pdf_id + '/').then(response => {
                if (response.status == 200) {
                    this.tx = response.data.certification.hash;
                    this.network = response.data.certification.network;
                    this.urltx = "https://polygonscan.com/tx/" + response.data.certification.hash;
                }
            });
        },
        async getSenderInfo(selected) {
            this.senderEmail = selected;
            this.imagesLoading = true;
            await axios.get('/api/File/GetSignatureDetail/' + this.pdf_id + '/' + selected).then(response => {
                this.user_captured = response.data.Result;
                this.signDate = this.user_captured.DateSign;
                this.imagesLoading = false;
            });
        },
        printPdf() {
            let config = { responseType: 'blob' }
            this.print = true;
            axios.get('/api/File/GetFilePrint/' + this.pdf_id + '/' + this.print + '/' + this.email, config).then(response => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                this.$print(fileURL);
                this.print = false;
            });
        },
        downloadPdf() {
            window.open('/api/File/GetFilePrint/' + this.pdf_id + '/' + this.print + '/' + this.email);
        },
        getNameById(id) {
            const option = this.sign_options.find(option => option.id === id);
            return option ? option.name : "Opción no encontrada";
        },
        async showPreview() {
            this.show = true;
            let config = { responseType: 'blob' }
            await axios.get('/api/File/GetFilePrint/' + this.pdf_id + '/' + this.print + '/' + this.email, config).then(response => {
                this.src = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                this.$bvModal.show('preview');
                this.show = false;
            });
        },
        initialValidation() {
            if (this.$route.params.security) {
                localStorage.clear();
            }
            if (!this.$store.getters.loggedIn) {
                axios.get('/api/File/GetUserByFileId/' + this.pdf_id).then(response => {
                    if (response.data.IsSuccessFul) {
                        this.userName = response.data.Result.Username;
                    }
                });
            } else {
                this.userName = this.$store.state.userName
            }
        },
        backToList() {
            this.$router.push({ name: 'list' });
        },
        zoomImage(url) {
            this.selectedImage = url;
            this.imageModal = true;
        },
        async generateReport() {
            
            let MyDate = new Date();
            MyDate.setUTCHours(MyDate.getUTCHours()); // Ajustar a la zona horaria GMT
            let ZonaHoraria = MyDate.toTimeString();

            for (let i = 0; i < this.senders.length; i++) {
                await this.getSenderInfo(this.senders[i].SendTo)
                this.senders[i].SenderInfo = this.user_captured;
                this.senders[i].SignatureOption = this.getNameById(this.pdf_signature_type)
            }

            this.reportData = {
                Hash: this.hash,
                FileName: this.pdf_name,
                FileId: this.pdf_id,
                FileState: this.state,
                FileCreated: this.pdf_created,
                TimeZone: ZonaHoraria,
                GuidedSignature: this.userPositionSignatures > 0 ? "Activado" : "Desactivado",
                Folder: this.pdf_folder,
                FileCreatorName: this.pdf_creator_name,
                FileCreatorEmail: this.pdf_creator_email,
                FileSenders: this.senders
            }

            this.$bvModal.show('preview-report');

        },
        hideGeneratePDF() {
            this.$bvModal.hide('preview-report');
        },
        async setPDF() {
            const elementoPDF = document.querySelector('#elementoPDF');
            generarPDF(elementoPDF,this.hash.substring(0, 8),this.pdf_name);
            setTimeout(() => {
                this.hideGeneratePDF();
            }, 2000);
        },

    }
}
</script>

<style scoped>
.summary-title {
    font-size: 14px;
    font-weight: 500;
    color: #9c9c9ce8;
}

.sender-select {
    background-color: #ECEEF3;
    border: 0;
    border-radius: 25px !important;
    padding-left: 1.3rem;
    font-size: 14px;
    color: #2E344A;
}

.sender-select option {
    background-color: #fff;
}

.VueCarousel-slide img {
    width: 14rem;
    border-radius: 10px;
}

.mouse-btn {
    margin: 10px auto;
    width: 40px;
    height: 80px;
    border: 3px solid rgba(122, 122, 124, 0.918);
    border-radius: 20px;
    display: flex;
}

.mouse-scroll {
    display: block;
    width: 20px;
    height: 20px;
    background: linear-gradient(170deg, rgba(122, 122, 124, 0.918), rgb(123, 124, 124));
    border-radius: 50%;
    margin: auto;
    animation: scrolling13 1s linear infinite;
}

@keyframes scrolling13 {
    0% {
        opacity: 0;
        transform: translateY(-20px);
    }

    100% {
        opacity: 1;
        transform: translateY(20px);
    }
}

#elementoPDF {
    min-width: 792px;
    max-width: 792px;
    min-height: 984px;
    max-height: 984px;
    background-color: #fff;
    padding: 20px;
}

.floating-button {
    max-width: 250px;
    position: fixed;
    bottom: 0%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
}</style>

